// Runtime polyfills for legacy browsers (Android 5+/6+ Chrome, iOS 12+ Safari,
// old Firefox). Loading core-js FIRST ensures Promise/Map/Set/Symbol/etc. are
// available before any of our code — or React's — runs.
import "core-js/stable";
import "regenerator-runtime/runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

// Register service worker for PWA + push notifications.
// SKIP registration in Median.co / GoNative WebView shells — those shells
// manage their own caching and the SW's offline fallback was racing with
// the WebView's initial load to show a false "no internet" screen.
if ("serviceWorker" in navigator) {
  const ua = (navigator.userAgent || "").toLowerCase();
  const isMedianShell = /median|gonative|talabya-app/.test(ua);
  if (!isMedianShell) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {});
    });
  } else {
    // If a previous SW was installed on this device before we started
    // detecting the shell, unregister it so its old offline fallback stops
    // hijacking navigations inside the Median WebView.
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister().catch(() => {}));
    }).catch(() => {});
  }
}
